import { render } from "./CloseActivity.vue?vue&type=template&id=20a25ff8&scoped=true"
import script from "./CloseActivity.vue?vue&type=script&lang=js"
export * from "./CloseActivity.vue?vue&type=script&lang=js"

import "./CloseActivity.vue?vue&type=style&index=0&id=20a25ff8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a25ff8"]])

export default __exports__